import { render, staticRenderFns } from "./TerminateMode.vue?vue&type=template&id=1c10f5e4&lang=pug&"
import script from "./TerminateMode.vue?vue&type=script&lang=ts&"
export * from "./TerminateMode.vue?vue&type=script&lang=ts&"
import style0 from "./TerminateMode.vue?vue&type=style&index=0&id=1c10f5e4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports